import { useEffect } from "react";
import { motion } from "framer-motion";

export default function Calculating({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 2200);
    return () => clearTimeout(t);
  }, [onDone]);

  const lines = ["Reading your figures", "Estimating owner earnings", "Applying market multiples", "Cross-checking fit-out value"];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full max-w-xl"
      data-testid="calculating-screen"
    >
      <div className="eyebrow text-brand mb-6">Please wait</div>
      <h2 className="font-serif font-light text-5xl md:text-6xl tracking-tight mb-12">
        Calculating your
        <br />
        valuation&hellip;
      </h2>
      <div className="space-y-4">
        {lines.map((l, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, x: -12 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: i * 0.45 }}
            className="flex items-center gap-3 text-lg text-muted-foreground"
          >
            <motion.span
              className="w-2 h-2 rounded-full bg-brand"
              animate={{ scale: [1, 1.6, 1] }}
              transition={{ repeat: Infinity, duration: 1, delay: i * 0.2 }}
            />
            {l}
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
